import type { UseMutationOptions } from '@tanstack/react-query';
import { queryClient } from '@quoruum/frontend-common/api/queryClient';

/** Runs a generated SDK mutation outside of a component. */
export function runMutation<TData, TError, TVariables>(
  options: UseMutationOptions<TData, TError, TVariables>,
  variables: TVariables
): Promise<TData> {
  return queryClient.getMutationCache().build(queryClient, options).execute(variables);
}
